<template>
  <div></div>
</template>

<script setup>
defineOptions({ name: "PageHeader" });
</script>
